<template>
	<div class="home-page">
		
		<van-overlay :show="uploading">
			<div style="position: absolute;width: 100%;top: 45%;left: 0;">
				<div class="upload-overlay">
					<van-loading type="spinner" color="#fff" />
					<div class="upload-text">{{ uploadProgress }}</div>
				</div>
			</div>
			
		</van-overlay>

		<div v-if="showDetail" class="detail-wrapper">
			<Detail :option-id="currentOptionId" :voteid="voteid" :wxopenid="wxopenid"
				:voteStartsign="vote_startsign" @back="onDetailBack"
				@voted="onDetailVoted" @vote-limit="onVoteLimit" />
		</div>

		<div v-if="!showDetail" class="page-bg">
			<div class="top-img-view">
				<img src="@/assets/new/top.jpg" class="top-img" />
				<div class="tab-bar">
					<img src="@/assets/new/tab1.png" :class="['tab-img', { 'tab-active': activeTab === 1 }]"
						@click="switchTab(1)" />
					<img src="@/assets/new/tab2.png" :class="['tab-img', { 'tab-active': activeTab === 2 }]"
						@click="switchTab(2)" />
					<img src="@/assets/new/tab3.png" :class="['tab-img', { 'tab-active': activeTab === 3 }]"
						@click="switchTab(3)" />
				</div>
			</div>



			<div v-show="activeTab === 1" class="tab-content">
				<img src="../assets/new/bot.png" style="width: 100%;position: absolute;bottom: 0;left: 0;"/>
				<div style="position: relative;">
					<div style="text-align: center;">
						<img src="../assets/new/sm.png" style="width: 100%;"/>
					</div>
					<div class="form-section">
						<div class="form-card">
							
							<div class="form-item">
								<img src="../assets/new/zpmc.png" class="form-item-label" />
								<div class="input-div">
									<input type="text" v-model="form.zpname" class="custom-input" />
								</div>
							</div>
							
							<div class="form-item">
								<img src="../assets/new/zplb.png" class="form-item-label" />
								<div class="input-div">
									<input type="text" v-model="form.zpcategory" readonly @click="zpcategoryShow = true" class="custom-input" />
								</div>
								<van-popup v-model="zpcategoryShow" round position="bottom">
									<van-cascader
										v-model="zpcategoryValue"
										title="请选择参与类型"
										:options="zpcategoryOptions"
										@close="zpcategoryShow = false"
										@finish="onZpcategoryFinish"
									/>
								</van-popup>
							</div>
							
							<div class="form-item">
								<img src="../assets/new/zpnr.png" class="form-item-label" />
								<div class="form-upload-div">
									<van-uploader
										v-model="fileList"
										:after-read="(file) => afterRead(file, '视频作品')"
										:accept="'.mp4,MP4'"
										:multiple="false"
										:max-size="800*1024*1024"
										:max-count="1"
										@oversize="oversize"
									>
										<div class="form-upload-btn">
											<img src="../assets/new/jia.png" style="width: 12vw;"/>
											<img src="../assets/new/scsp_wz.png" style="width: 19vw;margin-left: 10px;"/>
										</div>
									</van-uploader>
								</div>
							</div>
							
							<div class="form-item">
								<img src="../assets/new/scfm.png" class="form-item-label" />
								<div class="form-upload-div">
									<van-uploader
										v-model="posterFileList"
										:after-read="(file) => afterRead(file, '封面')"
										:accept="'image/*'"
										:multiple="false"
										:max-size="10*1024*1024"
										:max-count="1"
										@oversize="oversize"
									>
										<div class="form-upload-btn">
											<img src="../assets/new/jia.png" style="width: 12vw;"/>
											<img src="../assets/new/sczp_wz.png" style="width: 19vw;margin-left: 10px;"/>
										</div>
									</van-uploader>
								</div>
							</div>
							
							<div class="form-item">
								<img src="../assets/new/zpjj.png" class="form-item-label" />
								<div class="text-div">
									<van-field 
										v-model="form.zpintroduction" 
										:maxlength="1000" 
										type="textarea" placeholder="100字以内" 
										rows="3"
										class="custom-textarea" />
								</div>
							</div>
							
							<div class="form-item">
								<img src="../assets/new/zsxm.png" class="form-item-label" />
								<div class="input-div">
									<input type="text" v-model="form.username" class="custom-input" />
								</div>
							</div>
							<div class="form-item">
								<img src="../assets/new/lxdh.png" class="form-item-label" />
								<div class="input-div">
									<input type="text" v-model="form.phone" class="custom-input" />
								</div>
							</div>
							
							<div class="form-item">
								<img src="../assets/new/grxx.png" class="form-item-label" />
								<div class="form-upload-div">
									<van-uploader
										v-model="userimgFileList"
										:after-read="(file) => afterRead(file, '个人形象')"
										:accept="'image/*'"
										:multiple="false"
										:max-size="10*1024*1024"
										:max-count="1"
										@oversize="oversize"
									>
										<div class="form-upload-btn">
											<img src="../assets/new/jia.png" style="width: 12vw;"/>
											<img src="../assets/new/sczp_wz.png" style="width: 19vw;margin-left: 10px;"/>
										</div>
									</van-uploader>
								</div>
							</div>
							
							<div class="form-item">
								<img src="../assets/new/grjj.png" class="form-item-label" />
								<div class="text-div">
									<van-field 
										v-model="form.userintroduction" 
										:maxlength="1000" 
										type="textarea" placeholder="100字以内" 
										rows="3"
										class="custom-textarea" />
								</div>
							</div>
							<div class="form-item">
								<img src="../assets/new/szdq.png" class="form-item-label" />
								<div class="input-div">
									<input type="text" v-model="form.cityname" readonly @click="cityShow = true" class="custom-input" />
								</div>
								<van-popup v-model="cityShow" round position="bottom">
									<van-cascader
										v-model="cityValue"
										title="请选择所在地区"
										:options="cityOptions"
										:field-names="fieldNames"
										@close="cityShow = false"
										@finish="onFinish"
									/>
								</van-popup>
							</div>
							<div class="form-item">
								<img src="../assets/new/wlzh.png" class="form-item-label" />
								<div class="input-div">
									<input type="text" v-model="form.useraccount" class="custom-input" />
								</div>
							</div>
							
							<div class="form-item">
								<img src="../assets/new/zpfbpt.png" class="form-item-label" />
								<div class="input-div" style="width: 28%;">
									<input type="text" v-model="form.liveplatform" class="custom-input" />
								</div>
							</div>
							<div class="form-item">
								<img src="../assets/new/fsl.png" class="form-item-label" />
								<div class="input-div">
									<input type="text" v-model="form.fansnum" class="custom-input" />
								</div>
							</div>
							
							<!-- <div class="form-item">
								<div class="form-item-label">地区</div>
								<div class="input-div">
									<input type="text" v-model="form.cityname" readonly @click="cityShow=true" placeholder="请选择" class="custom-input" />
								</div>
								<van-popup v-model="cityShow" round position="bottom">
									<van-cascader
										v-model="cityValue"
										title="请选择所在地区"
										:options="cityOptions"
										:field-names="fieldNames"
										@close="cityShow = false"
										@finish="onFinish"
									/>
								</van-popup>
							</div> -->
										
							<!-- 
							<div style="margin-top: 15px;">
								<van-uploader 
									v-model="ryFileList"
									:after-read="(file) => afterRead(file, '荣誉证明')"
									accept=".PDF,.pdf"
									:multiple="false"
									:max-size="10*1024*1024"
									:max-count="1"
									@oversize="oversize"
									upload-icon="plus"
								/>
							</div> -->
							
							
							
							<div class="submit-btn" @click="tijiao">
								<img src="../assets/new/tj.png" style="width: 40%;" />
							</div>
						</div>
						<div style="text-align: center;padding: 30px 0 60px;">
							<img src="../assets/new/dw.png" style="width: 40%;" />
						</div>
					</div>
								
				</div>
				
			</div>
			
			
			<div v-if="activeTab === 2" class="tab-content">
				<div>
					
					<div class="search-section">
						<div style="margin: 0 5%;">
							<div style="text-align: center;">
								<img src="../assets/new/tpsm.png" style="width: 65%;"/>
							</div>
						</div>
						
						<div class="tab2-bg">
							<div style="overflow-x: auto;width: 100%;white-space: nowrap;-webkit-overflow-scrolling: touch;position: relative;">
								<div @click="changeAllSub(index)" v-for="(item,index) in sublist" :class="all_subcolumindex==index?'tab2 tab2-act':'tab2'">{{item.subcolumnname}}</div>
								
							</div>
						</div>
						<div style="margin: 0 5%;">
							<div style="position: relative;font-size: 0;width: 85%;margin: 0 auto;margin-top: 15px;">
								<img src="../assets/new/ssbg.png" style="width: 100%;"/>
								<div class="inputsr">
									<input type="text" v-model="allKeyword" placeholder="请输入名称或者序号进行搜索" />
									<div @click="onAllSearch" class="ss_btn"></div>
								</div>
							</div>
						</div>
						
					</div>
					<div class="list-wrapper" style="margin: 0 5%;">
						<div class="list-inner">
							<van-list v-model="allLoading" :finished="allFinished" finished-text="没有更多了"
								@load="onAllLoad" :immediate-check="false">
								<div class="list-container">
									<div v-for="(item, index) in allList" :key="'all-' + item.option_id" class="listdiv"
										:style="{ marginLeft: index % 2 === 0 ? '0' : '2%' }"
										@click="goDetail(item.option_id)">
										<div class="xuhao">{{item.option_num}}</div>
										<div class="coverss"
											:style="{ background: 'url(' + item.option_pic + ')', backgroundPosition: 'center', backgroundSize: 'cover' }"
											>
										</div>
										<div class="titlewz">{{ item.option_title }}</div>
										
										<template v-if="vote_startsign === 'yes'">
											<div class="piaodiv">
												<span>{{item.option_vnum}}</span><span style="color: #f26510;margin-left: 5px;">票</span>
											</div>
											<img src="@/assets/new/vote_btn.png" class="vote-btn"
												@click.stop="handleVote(item.option_id, item.option_subcolumnid)" />
											
										</template>
									</div>
								</div>
							</van-list>
						</div>
					</div>
				</div>
			</div>

			<div v-if="activeTab === 3" class="tab-content">
				<div>
					<div class="search-section">
						<div style="margin: 0 5%;">
							<div style="text-align: center;">
								<img src="../assets/new/tpsm.png" style="width: 65%;"/>
							</div>
						</div>
						
						<div class="tab2-bg">
							<div style="overflow-x: auto;width: 100%;white-space: nowrap;-webkit-overflow-scrolling: touch;position: relative;">
								<div @click="changeHotSub(index)" v-for="(item,index) in sublist" :class="hot_subcolumindex==index?'tab2 tab2-act':'tab2'">{{item.subcolumnname}}</div>
							</div>
						</div>
						<div style="margin: 0 5%;">
							<div style="position: relative;font-size: 0;width: 85%;margin: 0 auto;margin-top: 15px;">
								<img src="../assets/new/ssbg.png" style="width: 100%;"/>
								<div class="inputsr">
									<input type="text" v-model="hotKeyword" placeholder="请输入名称或者序号进行搜索" />
									<div @click="onHotSearch" class="ss_btn"></div>
								</div>
							</div>
						</div>
						
					</div>
					<div class="list-wrapper" style="margin: 0 5%;">
						<div class="list-inner">
							<van-list v-model="hotLoading" :finished="hotFinished" finished-text="没有更多了"
								@load="onHotLoad" :immediate-check="false">
								<div class="list-container">
									<div v-for="(item, index) in hotList" :key="'hot-' + item.option_id" class="listdiv"
										:style="{ marginLeft: index % 2 === 0 ? '0' : '2%' }"
										@click="goDetail(item.option_id)">
										<div class="xuhao">{{item.option_num}}</div>
										<div class="coverss"
											:style="{ background: 'url(' + item.option_pic + ')', backgroundPosition: 'center', backgroundSize: 'cover' }"
											>
										</div>
										<div class="titlewz">{{ item.option_title }}</div>
										
										<template v-if="vote_startsign === 'yes'">
											<div class="piaodiv">
												<span>{{item.option_vnum}}</span><span style="color: #f26510;margin-left: 5px;">票</span>
											</div>
											<img src="@/assets/new/vote_btn.png" class="vote-btn"
												@click.stop="handleVote(item.option_id, item.option_subcolumnid)" />
											
										</template>
									</div>
								</div>
							</van-list>
						</div>
					</div>
				</div>

			</div>
		</div>

		<!-- <van-back-top bottom="60" /> -->
	</div>
</template>

<script>
	import Toast from 'vant/lib/toast'
	import 'vant/lib/toast/style';
	import Detail from './detail.vue'
	import {
		getVoteList,
		searchVoteList,
		uploadImage,
		uploadFile,
		submitEntry,
		visitLog,
		getCityList,
		getSubcategoryList,
		getBigFileUploadUrl
	} from '@/api'
	import {
		getQueryString,
		isJiyun
	} from '@/utils'
	
	export default {
		name: 'Home',
		components: {
			Detail
		},
		data() {
			return {
				sign_file_url:'',
				
				cityShow:false,
				cityValue:null,
				cityOptions:[],
				
				
				
				vote_startsign:'no',
				activeTab: 1,
				voteid: null,
				wxopenid: '',
				uploading: false,
				uploadProgress: '',
				picurl: '',
				workPicurl: '',
				honorPicurl: '',
				supplementPicurl: '',
				showDetail: false,
				currentOptionId: '',
				scrollTop: 0,
				
				zpcategoryValue:null,
				zpcategoryOptions:[{text: '主播带货',value: 1},{text: 'AI创作',value: 2}],
				zpcategoryShow: false,
				
				form: {
					zpname:"",
					zpcategory:"",
					zpcoverimg:"",
					zpurl:"",
					zpintroduction:"",
					username:"",
					phone:"",
					userimg:"",
					userintroduction:"",
					useraccount:"",
					liveplatform:"",
					fansnum:"",
					cityname:''
				},
				
				hot_subcolumnid: null,
				hot_subcolumindex: 0,
				hotKeyword: '',
				hotList: [],
				hotPage: 1,
				hotLoading: false,
				hotFinished: false,
				hotSearchMode: false,
				
				all_subcolumnid: null,
				all_subcolumindex: 0,
				allKeyword: '',
				allList: [],
				allPage: 1,
				allLoading: false,
				allFinished: false,
				allSearchMode: false,
				
				
				sxflag: false,
				
				fieldNames: {
					text: 'cityname',
					value: 'cityid',
					children: 'children'
				},
				
				
				subcategoryShow:false,
				subcategoryValue:null,
				subcategoryOptions:[],
				subcategoryFieldNames: {
					text: 'categoryname',
					value: 'categoryid',
					children: 'subcategorylist'
				},
				
				
				zpFileName:null,
				honorFileName:null,
				supplementFileName:null,
				
				
				fileList:[],
				posterFileList:[],
				userimgFileList:[],
				ryFileList:[],
				bcFileList:[],
				
				
				
				
				sublist:[]
			}
		},
		// computed: {
		// 	zpAccept(){
				
		// 		if (this.form.subcategory=='文字作品'||this.form.subcategory=='计算机软件'||this.form.subcategory=='其他作品') {
		// 			return '.PDF,.pdf';
		// 		} else if (this.form.subcategory=='口述作品'||this.form.subcategory=='音乐作品'){
		// 			return '.MP3,.mp3';
		// 		} else if (this.form.subcategory=='视频作品'){
		// 			return '.MP4,.mp4';
		// 		}else{
		// 			return 'image/*';
		// 		}
		// 	},
		// 	maxSize(){
		// 		if (this.form.subcategory=='文字作品'||this.form.subcategory=='计算机软件'||this.form.subcategory=='其他作品') {
		// 			return 20*1024*1024
		// 		} else if (this.form.subcategory=='口述作品'||this.form.subcategory=='音乐作品'){
		// 			return 20*1024*1024
		// 		} else if (this.form.subcategory=='视频作品'){
		// 			return 800*1024*1024
		// 		}else{
		// 			return 20*1024*1024
		// 		}
		// 	}
		// },
		created() {
			this.initParams()
			this.handleOptionid()
			visitLog()
			this.onHotLoad()
			this.onAllLoad()
			this.getCity()
		},
		methods: {
			oversize(){
				Toast('文件过大')
			},
			afterRead(file,type){
				console.log("afterRead:",file)
				this.uploading = true
				this.uploadProgress = '已上传0%'
				if(type=='视频作品'){
					getBigFileUploadUrl().then(res => {
						
						this.sign_file_url = res.data
						uploadFile(file.file, type, (progressEvent) => {
							if (progressEvent.lengthComputable) {
								var percent = Math.round(progressEvent.loaded / progressEvent.total * 100)
								this.uploadProgress = '已上传' + percent + '%'
							}
						},this.sign_file_url).then(res => {
							
							let video_url = this.sign_file_url.split('?')[0]
							this.form.zpurl = video_url.split("https://yanfa-upload-1330455741.cos.ap-beijing.myqcloud.com/")[1]
							Toast('上传完成')
							this.uploading = false
						}).catch(() => {
							Toast('上传失败')
							this.fileList=[];
							this.uploading = false
						})
					}).catch(() => {
						Toast('上传失败')
						this.fileList=[];
						this.uploading = false
					})
				}else{
					uploadFile(file.file, type, (progressEvent) => {
						if (progressEvent.lengthComputable) {
							var percent = Math.round(progressEvent.loaded / progressEvent.total * 100)
							this.uploadProgress = '已上传' + percent + '%'
						}
					}).then(res => {
						
						let data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
						console.log("file-data:",data.code)
						if (data.code == 1) {
							if (type=='封面'){
								this.form.zpcoverimg = data.data.picurl
							} else if (type=='个人形象'){
								this.form.userimg = data.data.picurl
							} else {
								this.form.zpurl = data.data.picurl
							}
							
							// this.fileList = [{ url: this.form.zpurl }]
							Toast('上传完成')
						} else {
							Toast(data.msg || '上传失败')
							if (type=='封面'){
								this.posterFileList=[];
							} else if (type=='个人形象'){
								this.userimgFileList = []
							} else {
								this.fileList=[];
							}
						}
						this.uploading = false
					}).catch(() => {
						Toast('上传失败')
						if (type=='封面'){
							this.posterFileList=[];
						} else if (type=='个人形象'){
							this.userimgFileList = []
						} else {
							this.fileList=[];
						}
						this.uploading = false
					})
				}
				
			},
			getCity(){
				getCityList().then(res => {
					let data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					this.cityOptions = data.data
				})
			},
			onFinish({ selectedOptions }) {
				this.cityShow = false;
				this.form.cityname = selectedOptions.map((option) => option.cityname).join('/');
			},
			
			
			
			onZpcategoryFinish({ selectedOptions }) {
				this.zpcategoryShow = false;
				this.form.zpcategory = selectedOptions.map((option) => option.text).join('/');
			},
			
			
			initParams() {
				this.wxopenid = getQueryString('openid')
				var voteid = getQueryString('voteid')
				if (voteid) this.voteid = voteid
			},
			
			handleOptionid() {
				var optionid = getQueryString('optionid')
				if (optionid) {
					this.goDetail(optionid)
				}
			},
			switchTab(tab) {
				this.activeTab = tab
				if (tab === 3 && this.hotList.length === 0 && !this.hotLoading) {
					this.hotLoading = true
					this.fetchHotSearchList()
				}
				
				if (tab === 2 && this.allList.length === 0 && !this.allLoading) {
					this.allLoading = true
					this.fetchAllSearchList()
				}
			},
			goDetail(optionId) {
				this.scrollTop = window.scrollY
				this.currentOptionId = optionId
				// this.vote_startsign = data.vote_startsign
				this.showDetail = true
			},
			onDetailBack() {
				this.showDetail = false
				this.currentOptionId = ''
				this.$nextTick(() => {
					window.scroll(0, this.scrollTop)
				})
			},
			onDetailVoted(optionId) {
				this.updateVoteCount(optionId)
			},
			onVoteLimit() {
				this.sxflag = true
			},
			
			tijiao() {
				if (!this.form.zpname.trim()) {
					Toast('请输入作品名称')
					return
				}
				
				if (!this.form.zpcategory.trim()) {
					Toast('请选择作品类别')
					return
				}
				if (!this.form.zpcoverimg) {
					Toast('请上传作品封面')
					return
				}
				if (!this.form.zpurl) {
					Toast('请先上传作品')
					return
				}
				if (!this.form.zpintroduction.trim()) {
					Toast('请输入作品简介')
					return
				}
				
				if (!this.form.username.trim()) {
					Toast('请输入真实姓名')
					return
				}
				if (!this.form.phone.trim()) {
					Toast('请填写联系电话')
					return
				}
				if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
					Toast('请输入正确的手机号码')
					return
				}
				if (!this.form.userimg) {
					Toast('请先上传个人形象')
					return
				}
				
				
				if (!this.form.userintroduction.trim()) {
					Toast('请输入个人简介')
					return
				}
				if (!this.form.cityname.trim()) {
					Toast('请选择地区')
					return
				}
				if (!this.form.useraccount.trim()) {
					Toast('请输入网络账号')
					return
				}
				
				if (!this.form.liveplatform.trim()) {
					Toast('请输入作品发布/直播平台')
					return
				}
				if (!this.form.fansnum.trim()) {
					Toast('请输入粉丝量')
					return
				}
				
				this.uploading = true
				this.uploadProgress = '提交中...'
				submitEntry(this.form).then(res => {
					this.uploading = false
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data.code + '' === '1') {
						this.form = {
							zpname:"",
							zpcategory:"",
							zpcoverimg:"",
							zpurl:"",
							zpintroduction:"",
							username:"",
							phone:"",
							userimg:"",
							userintroduction:"",
							useraccount:"",
							liveplatform:"",
							fansnum:"",
							cityname:''
						}
						this.zpcategoryValue = null
						this.fileList=[];
						this.posterFileList=[];
						this.userimgFileList=[];
						Toast('提交信息成功')
					} else {
						Toast(data.data || '提交失败')
					}
				}).catch(() => {
					this.uploading = false
					Toast('提交信息失败，请重试')
				})
			},
			handleVote(optionId, option_subcolumnid) {
				if (isJiyun()) {
					Toast('请分享到微信客户端内打开链接参与投票')
					return
				}
				if (this.sxflag) {
					Toast('您今天已达投票上限')
					return
				}
				try {
					var captcha = new TencentCaptcha('190326154', (res) => {
						this.onCaptchaCallback(res, optionId, option_subcolumnid)
					}, {
						userLanguage: 'zh-cn'
					})
					captcha.show()
				} catch (error) {
					this.loadErrorCallback(optionId)
				}
			},
			onCaptchaCallback(res, optionId, option_subcolumnid) {
				if (res.ret === 0) {
					var params = {
						Ticket: res.ticket,
						Randstr: res.randstr,
						wxopenid: this.wxopenid,
						option_id: optionId,
						option_subcolumnid: option_subcolumnid,
						option_voteid: this.voteid
					}
					this.$api.submitVote(params).then(response => {
						var data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
						if (data.code == 1) {
							this.updateVoteCount(optionId)
							Toast('投票成功')
						} else {
							Toast(data.msg || '投票失败')
							if (data.msg && data.msg.indexOf('上限') > -1) {
								this.sxflag = true
							}
						}
					})
				}
			},
			loadErrorCallback(optionId) {
				var appid = '190326154'
				var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000)
				this.onCaptchaCallback({
					ret: 0,
					randstr: '@' + Math.random().toString(36).substr(2),
					ticket: ticket,
					errorCode: 1001,
					errorMessage: 'jsload_error'
				}, optionId)
			},
			updateVoteCount(optionId) {
				this.hotList.forEach(item => {
					if (item.option_id == optionId) {
						item.option_vnum = parseInt(item.option_vnum) + 1
					}
				})
				this.allList.forEach(item => {
					if (item.option_id == optionId) {
						item.option_vnum = parseInt(item.option_vnum) + 1
					}
				})
			},
			
			onHotLoad() {
				if (this.hotSearchMode) {
					this.fetchHotSearchList()
				} else {
					this.fetchHotList()
				}
			},
			fetchHotList() {
				var params = {
					order: 'hot',
					pagenow: this.hotPage,
					voteid: this.voteid
				}
				getVoteList(params).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					var list = data.data.sublist[this.hot_subcolumindex].vote_list || []
					this.hotList = this.hotPage === 1 ? list : this.hotList.concat(list)
					this.vote_startsign = data.data.vote_startsign
					this.hotLoading = false
					if (list.length < 20 || this.hotPage >= data.data.sublist[this.hot_subcolumindex].pagecount) {
						this.hotFinished = true
					}
					this.hotPage++
					
					if(!this.loadSubList){
						this.loadSubList = true
						
						for (let index = 0; index < data.data.sublist.length; index++) {
							this.sublist.push({
								subcolumnid:data.data.sublist[index].subcolumnid,
								subcolumnname:data.data.sublist[index].subcolumnname
							})
						}
						this.hot_subcolumnid = this.sublist[0].subcolumnid
						this.all_subcolumnid = this.sublist[0].subcolumnid
					}
				}).catch(() => {
					this.hotLoading = false
					this.hotFinished = true
				})
			},
			fetchHotSearchList() {
				var params = {
					pagenow: this.hotPage,
					keyword: this.hotKeyword,
					order: 'hot',
					subcolumnid:this.hot_subcolumnid,
					voteid: this.voteid
				}
				searchVoteList(params).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					var list = data.data.sublist.vote_list || []
					this.hotList = this.hotPage === 1 ? list : this.hotList.concat(list)
					this.vote_startsign = data.data.vote_startsign
					this.hotLoading = false
					if (list.length < 20 || this.hotPage >= data.data.pagecount) {
						this.hotFinished = true
					}
					this.hotPage++
				}).catch(() => {
					this.hotLoading = false
					this.hotFinished = true
				})
			},
			onHotSearch() {
				this.hotSearchMode = true
				this.hotPage = 1
				this.hotList = []
				this.hotFinished = false
				this.hotLoading = true
				this.onHotLoad()
			},
			changeHotSub(index){
				this.hot_subcolumindex = index;
				this.hot_subcolumnid = this.sublist[index].subcolumnid
				this.hotPage = 1
				this.hotList = []
				this.hotFinished = false
				this.hotLoading = true
				this.onHotLoad()
			},
			
			
			
			onAllLoad() {
				if (this.allSearchMode) {
					this.fetchAllSearchList()
				} else {
					this.fetchAllList()
				}
			},
			fetchAllList() {
				var params = {
					order: 'all',
					pagenow: this.allPage,
					voteid: this.voteid
				}
				getVoteList(params).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					var list = data.data.sublist[this.all_subcolumindex].vote_list || []
					this.allList = this.allPage === 1 ? list : this.allList.concat(list)
					this.vote_startsign = data.data.vote_startsign
					this.allLoading = false
					if (list.length < 20 || this.allPage >= data.data.sublist[this.all_subcolumindex].pagecount) {
						this.allFinished = true
					}
					this.allPage++
					
				}).catch(() => {
					this.allLoading = false
					this.allFinished = true
				})
			},
			fetchAllSearchList() {
				var params = {
					pagenow: this.allPage,
					keyword: this.allKeyword,
					order: 'all',
					subcolumnid:this.all_subcolumnid,
					voteid: this.voteid
				}
				searchVoteList(params).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					var list = data.data.sublist.vote_list || []
					this.allList = this.allPage === 1 ? list : this.allList.concat(list)
					this.vote_startsign = data.data.vote_startsign
					this.allLoading = false
					if (list.length < 20 || this.allPage >= data.data.pagecount) {
						this.allFinished = true
					}
					this.allPage++
				}).catch(() => {
					this.allLoading = false
					this.allFinished = true
				})
			},
			onAllSearch() {
				this.allSearchMode = true
				this.allPage = 1
				this.allList = []
				this.allFinished = false
				this.allLoading = true
				this.onAllLoad()
			},
			changeAllSub(index){
				this.all_subcolumindex = index;
				this.all_subcolumnid = this.sublist[index].subcolumnid
				this.allPage = 1
				this.allList = []
				this.allFinished = false
				this.allLoading = true
				this.onAllLoad()
			}
		}
	}
</script>

<style scoped>
	.home-page {
		min-height: 100vh;
	}

	.detail-wrapper {
		min-height: 100vh;
	}

	.page-bg {
		min-height: 100vh;
	}

	.bot-bg{
		background-image: url(../assets/new/bg2.jpg);
		background-size: 100% auto;
		background-repeat: repeat-y;
		position: relative;
	}
	.top-img-view {
		width: 100%;
		position: relative;
		font-size: 0;
	}
	
	.top-img {
		width: 100%;
		display: block;
	}
	
	.tab-bar {
		display: flex;
		justify-content: space-around;
		padding: 0px 15px;
		align-items: center;
		position: absolute;
		bottom: 0px;
		left: 0;
		width: 100%;
	}
	
	.tab-img {
		width: 30%;
		cursor: pointer;
		transition: opacity 0.2s;
		touch-action: manipulation;
	}
	
	.tab-active {
		opacity: 1;
	}
	
	.tab-content {
		background-image: url(../assets/new/bg2.jpg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding: 15px 0 10px;
		position: relative;
		margin-top: -1px;
	}
	
	.intro-section {
		text-align: center;
		/* padding: 0 15px; */
	}
	
	.form-title-section {
		padding: 15px 15px 0;
	}
	
	.form-title-wrapper {
		display: flex;
		align-items: center;
		background: linear-gradient(90deg, #1e40af, #3b82f6);
		padding: 12px 15px;
		border-radius: 8px;
	}
	
	.form-title-icon {
		width: 28px;
		height: 28px;
		margin-right: 10px;
	}
	
	.form-title-text {
		color: #ffffff;
		font-size: 1.1rem;
		font-weight: bold;
	}
	
	.form-section {
		width: 95%;
		margin: 0px auto;
		position: relative;
	}
	
	.form-card {
		padding: 20px 0;
	}
	
	.form-item {
		margin-top: 3px;
		position: relative;
		font-size:0;
	}
	
	.form-item-label {
		width:100%;
		
	}
	
	.form-tip {
		color: #9ca1b4;
		font-size: 0.9rem;
		margin-top: 15px;
		line-height: 1.8;
		text-align: justify;
	}
	
	.form-upload-tip {
		color: #666666;
		font-size: 0.9rem;
		line-height: 1.5;
		
		margin-top: 10px;
		display: flex;
		align-items: start;
	}
	
	.form-intro-tip {
		color: #666666;
		font-size: 0.8rem;
		padding: 5px 5% 10px;
	}
	.form-upload-div{
		position: absolute;
		width: 100%;
		right: 0px;
		bottom: 0;
		height: 65%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.form-upload-btn{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.text-div{
		position: absolute;
		width: 90%;
		right: 5%;
		bottom: 5%;
		height: 52%;
		
	}
	
	.input-div {
		position: absolute;
		width: calc(62% - 10px);
		right: 10px;
		top: 0;
		height: 100%;
	}
	
	.custom-input {
		background: none;
		border-radius: 10px;
		width: 100%;
		margin: 0 auto;
		border: none;
		outline: none;
		height: 100%;
		font-size: 1rem;
		color: #000;
		
	}
	.custom-input::placeholder{
		color: #9ca1b4;
	}
	.inputsr{
		display: flex;
		align-items: center;
		background-image: url(../assets/new/ssbg.png);
		background-size: 100% 100%;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
	}
	.inputsr input{
		height: 100%;
		width: 0;
		flex: 1;
		padding-left: 10px;
		border: none;
		outline: none;
		background: none;
		color: #000;
		font-size: 1rem;
	}
	.inputsr input::placeholder{
		color: #fff;
		font-weight: bold;
	}
	.inputsr .ss_btn{
		
		width: 20%;
		height: 100%;
	}
	.custom-textarea {
		background: none;
		margin: 0 auto;
	}
	
	.upload-area {
		background: #ffffff;
		border-radius: 8px;
		width: 30%;
		padding: 30px 0;
		text-align: center;
		min-height: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 0 2px #cbd5e1;
		cursor: pointer;
		touch-action: manipulation;
		margin-top: 15px;
	}
	
	.upload-placeholder {
		text-align: center;
		color: #3f3f3f;
		font-size: 2rem;
		font-weight: 300;
	}
	
	.upload-filename {
		font-size: 0.85rem;
		color: #333;
		word-wrap: break-word;
		padding: 0 15px;
	}
	
	.submit-btn {
		text-align: center;
		cursor: pointer;
		margin-top: 15px;
		touch-action: manipulation;
	}
	
	.search-section {
		
	}
	
	.search-input-wrapper {
		position: relative;
		width: 90%;
		margin: 0 auto;
	}
	
	.search-icon {
		position: absolute;
		right: 15px;
		top: 50%;
		transform: translateY(-50%);
		width: 24px;
		height: 24px;
		pointer-events: none;
	}
	
	
	.list-inner {
		
	
	}
	
	.list-container {
		font-size: 0;
	}
	.xuhao {
		border-radius: 10px 10px 0 0;
		color: #f26510;
		font-size: 1.1rem;
		padding: 1px 0 1px 10px;
		/* font-weight: bold; */
		/* white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis; */
	}
	.listdiv {
		position: relative;
		display: inline-block;
		width: 49%;
		border-radius: 10px;
		background-color: #ffffff;
		padding-bottom: 20px;
		margin-top: 15px;
		vertical-align: top;
		border: 1.5px solid #f26510;
		box-sizing: border-box;
	}
	
	.coverss {
		background-position: center;
		background-size: cover;
		display: inline-block;
		width: 100%;
		height: 0;
		padding-bottom: 75%;
		cursor: pointer;
		touch-action: manipulation;
	}
	
	
	.titlewz {
		font-size: 1rem;
		margin-top: 3px;
		color: #f26510;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: center;
		font-weight: 500;
	}
	
	.vote-btn {
		width: 65%;
		cursor: pointer;
		touch-action: manipulation;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%,55%);
	}
	
	.upload-overlay {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.upload-text {
		color: #fff;
		font-size: 1rem;
		margin-top: 10px;
	}
	.piaodiv {
		font-size: 1rem;
		margin-top: 3px;
		color: #f26510;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		
	}
	.van-cell{
		padding: 0 !important;
	}
	.tab2-bg{
		background-image: url(../assets/new/tab_bg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		width: 100%;
		margin: 0 auto;
		
		
		margin-top: 15px;
	}
	.tab2{
		color: #fff;
		font-size: 1.2rem;
		font-weight: bolder;
		padding: 7px 20px;
		display: inline-block;
		vertical-align: middle;
	}
	.tab2-act{
		border-radius: 15px;
		background-color: #f26510;
	}
</style>